import React from 'react';

import { createClassName } from 'utils/createClassName';

import './dashboardFooterLayoutStyles.scss';

type Props = {
  copyright: React.ReactNode;
  links: React.ReactNode;
};

export const DashboardFooterLayoutComponent: React.FC<Props> = (props) => {
  const { copyright, links } = props;

  const createElementClassName = createClassName('dashboardFooterLayout');

  return (
    <div className={createElementClassName('wrapper')}>
      <div className={createElementClassName('copyright')}>{copyright}</div>
      <div className={createElementClassName('links')}>{links}</div>
    </div>
  );
};
